import BinIcon from '../../../components/icon/IconWrapped';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { MouseEventHandler } from 'react';
import BannerForwardButton from '../BannerForwardButton/BannerForwardButton';
import { SelectAssetBannerStyled } from './styled/SelectAssetBannerStyled';

interface IMobilePortfolioSelectAssetBannerProps {
    onClick: MouseEventHandler<HTMLDivElement>;
}

function SelectAssetBanner(props: IMobilePortfolioSelectAssetBannerProps) {
    const { onClick } = props;
    const { getLangPath } = useLangContext();

    return <SelectAssetBannerStyled onClick={onClick}>
        <BinIcon name={'IcChartStatistic'} className={'icon'} size={40}/>
        <div className={'info'}>
            <h5 className={'title mb-0'}>{getLangPath('banners.select_asset.title')}</h5>
            <span className={'description'}>{getLangPath('banners.select_asset.description')}</span>
        </div>
        <BannerForwardButton/>
    </SelectAssetBannerStyled>
}

export default SelectAssetBanner;
